import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
  class: "mb-2 last:mb-0 rounded-xl"
};
const _hoisted_2 = {
  class: "p-2 flex items-center justify-center text-xs text-gray-400 mb-2"
};
const _hoisted_3 = {
  key: 0,
  class: "flex items-center justify-center"
};
import Match from "@/modules/competitions/components/Match.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Matchday',
  props: {
    matchday: null,
    competitionWinner: null,
    showConnectedMatches: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(__props.matchday.name) + " (" + _toDisplayString(_ctx.$date(__props.matchday.scheduledAt)) + ") ", 1), __props.matchday.matches.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, "--")) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(_ctx.collect(__props.matchday.matches).sortBy('id'), match => {
        return _openBlock(), _createElementBlock("div", {
          key: match.id,
          class: "py-2 text-sm mb-1 last:mb-0 bg-neutral-50 rounded"
        }, [_createVNode(Match, {
          match: match,
          "marker-winner": __props.competitionWinner
        }, null, 8, ["match", "marker-winner"])]);
      }), 128)), _renderSlot(_ctx.$slots, "footer")]);
    };
  }
});